/* RESPONSIBLE TEAM: team-knowledge-foundations */
import ApplicationAdapter from './application';

export default class ArticleContentAdapter extends ApplicationAdapter {
  buildURL(modelName, id, snapshot, requestType, query) {
    return query && (query.phrase || query.url_partials?.length > 0)
      ? '/ember/articles/search'
      : super.buildURL(modelName, id, snapshot, requestType, query);
  }
}
